<template>
  <div>
    <v-app-bar color="dark">
      <h1>Instrumentbräda</h1>
      <v-spacer />
      <v-btn style="color:#ffa500" text @click="reloadPage"
        ><v-icon>fas fa-sync</v-icon></v-btn
      >
      <router-link to="createmeeting">
        <v-btn style="color:#ffa500" text><v-icon>fas fa-plus</v-icon> </v-btn>
      </router-link>
    </v-app-bar>
    <div>
      <v-row class="hidden-sm-and-down">
        <v-container style="width:40%">
          <h2>Inkommande</h2>
          <Incoming />
        </v-container>
        <v-container style="width:40%"
          ><h2>Utgående</h2>
          <Outgoing />
        </v-container>
      </v-row>
      <v-container class="hidden-md-and-up">
        <h2>Inkommande</h2>
        <Incoming />
      </v-container>
      <v-container class="hidden-md-and-up"
        ><h2>Utgående</h2>
        <Outgoing />
      </v-container>
    </div>
  </div>
</template>

<script>
import store from "../../store";
import Outgoing from "./showevents/outgoing";
import Incoming from "./showevents/incoming";
export default {
  name: "Dashboard",
  components: {
    Outgoing,
    Incoming,
  },
  created: function() {
    if (!this.store.state.isLoggedIn) this.$router.replace("/login");
    if (this.store.state.user.role == "admin")
      this.$router.replace("/admin/dashboard");
  },
  data: () => ({
    isLoggedIn: null,
    store: store,
  }),
  methods: {
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>
